<template>
    <Modal :open="open" :narrow="false" :is-card="false" :is-dismissed-on-click-backdrop="true" :border-top="false"
        :show-close-icon="true" @close="$emit('close')">
        <template v-slot:body>
            <form v-if="!completed && loading === false" ref="form" method="post" class="material-form"
                data-form-name="Used Vehicles - Make An Enquiry">
                <h1>Make An Enquiry</h1>

                <div class="form-grid form-grid--xs-1-column">
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <TitalInput />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <FirstName />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <LastName />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <Email />
                    </div>
                    <div class="form-grid__col form-grid__col--xs-full-width">
                        <Telephone inputValidateMessage="Please enter a telephone number" />
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <GenericTextarea input-name="comments" input-title="Anything you'd like to ask?"
                            :input-validate="false" />
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <Privacy />
                    </div>
                    <div class="form-grid__col-span-2 form-grid__col--xs-full-width">
                        <button @click.prevent="submit" type="button" class="btn btn--primary btn--full-width-xs">
                            Send Enquiry
                        </button>
                    </div>
                </div>
            </form>
            <div v-else-if="loading === false">
                <h2>Thank you for your enquiry</h2>
                <p class="nice-text">
                    A member of the team will be in touch shortly to discuss your enquiry. If you would like to continue your search or get a free instant valuation please use the links below.
                </p>
                <div class="enquire-now__buttons">
                    <a href="/used-vehicles/results" class="btn btn--primary">Discover more</a>
                    <a href="/car-valuation" class="btn btn--full-width enquire-now__value-vehicle">Value my car</a>
                </div>
            </div>
            <div v-else > 
                <LoadingSpinner v-if="loading" />
             </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "../../../../core/components/Modal.vue";
import TitalInput from "../../Forms/redesign/Title.vue";
import FirstName from "../../Forms/redesign/FirstName.vue";
import LastName from "../../Forms/redesign/LastName.vue";
import Email from "../../Forms/redesign/Email.vue";
import Telephone from "../../Forms/redesign/Telephone.vue";
import GenericTextarea from '../../Forms/redesign/GenericTextarea.vue';
import Privacy from "../../Forms/redesign/Privacy.vue";
import LoadingSpinner from "../../../../core/components/LoadingSpinner.vue";


export default {
    components: {
        Modal,
        TitalInput,
        FirstName,
        LastName,
        Email,
        Telephone,
        GenericTextarea,
        Privacy,
        LoadingSpinner,
    },
    props: {
        open: {
            type: Boolean,
            default: false,
            required: false,
        },
        vehicle: {
            required: true,
        },
        quote: {
            required: true,
        },
        term: {
            required: true,
        },
        deposit: {
            required: true,
        },
        mileage: {
            required: true,
        },
    },
    computed: {
        quoteType() {
            if (typeof this.quote.Key !== 'undefined') {
                return this.quote.Key;
            }
            return false;
        },
    },
    data() {
        return {
            validator: false,
            completed: false,
            loading:false,
        };
    },
    watch: {
        open: function (n, o) {
            if (n == true) {
                this.gaTag('Used Vehicle', 'Enquire about finance - ' + this.quoteType, 'Opened');
            }
        },
    },
    methods: {
        async submit() {
            if (!await this.validator.isValid()) {
                return;
            }

            reCaptchaProtect(() => {
                this.loading = true;

                let formData = new FormData(this.$refs.form);
                formData.set('quote-type', this.quoteType);
                formData.set('quote', JSON.stringify(this.quote));
                formData.set('term', this.term);
                formData.set('deposit', this.deposit);
                formData.set('mileage', this.mileage);
                this.validator.preventInput();

                axios.post('/api/used-vehicles/finance-enquiry/' + this.vehicle.id, formData)
                    .then(response => {
                        this.gaTag('Used Vehicle', 'Enquire about finance - ' + this.quoteType, 'Complete');
                        this.trackPageView('/conversion/used-vehicle-enquire-about-finance/complete', 'Used Vehicle Enquire About Finance Completed');
                        this.generateLeadEvent('used_finance_enquiry');

                        this.completed = true;
                        this.loading = false;
                        this.validator.allowInput();
                    })
                    .catch(error => {
                        this.loading = false;
                        console.error(error)
                        this.validator.errorResponse(error);
                    })
            });
        }
    },
    mounted() {
        this.validator = new ContactFormValidator({
            element: $(this.$refs.form),
            vueForm: true
        });
    }
}
</script>

<style lang="scss" scoped>
    .enquire-now{
        &__buttons{
            margin: 2rem 0rem 1rem 0rem;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
            @media (max-width: 767px) {
                gap: 10px;
                grid-template-columns: repeat(1, 1fr);
            }
        }
        &__value-vehicle{
                color: #ffffff;
                background-color: #0093D6;
                &:hover {
                    transition: filter 0.3s ease-in-out;
                    filter: brightness(90%);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Finance/Quotes/EnquireNowForm.vue